import { LauncherElement } from '../../types/launcherElement';
import { createArrayStore } from '../dataStore/createArrayStore';

export const [ElementsProvider, useElements] =
  createArrayStore<LauncherElement>();
